module.exports = __webpack_public_path__ + "job-teaser-list-item-a44a05a5/super-ellipse-mask-cd22c3b8c137c9902b90787d046b531a.svg";